import SimpleMDE from "react-simplemde-editor";
import { Form, FormGroup, Input, Label } from "reactstrap";
import { Message, Subject, To } from "../../../Constant";

export const EmailComposeForm = () => {
  return (
    <Form className="theme-form">
      <FormGroup>
        <Label className="col-form-label pt-0" check>
          {To}
        </Label>
        <Input type="email" />
      </FormGroup>
      <FormGroup>
        <Label check>{Subject}</Label>
        <Input type="text" />
      </FormGroup>
      <div>
        <Label className="text-muted" check>
          {Message}
        </Label>
        <SimpleMDE
          id="editor_container"
          options={{
            autofocus: true,
            spellChecker: false,
          }} />
      </div>
    </Form>
  );
};
